/* Functions */

/* Bundle Product Form Append Start */
function createHiddenInput(name, value, className) {
    let input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('name', name);
    input.setAttribute('value', value);
    if (className) {
        input.setAttribute('class', className);
    }
    return input;
}

function appendProductInputs(formElement, productId, planId) {
    let baseName = 'items[1]';
    formElement.appendChild(createHiddenInput(`${baseName}[id]`, productId, 'ProductInput'));
    formElement.appendChild(createHiddenInput(`${baseName}[quantity]`, '1', 'ProductInput'));
    formElement.appendChild(createHiddenInput(`${baseName}[selling_plan]`, planId, 'ProductInput'));
}
/* Bundle Product Form Append End */

document.addEventListener('DOMContentLoaded', () => {

        /* Product Sticky Add To Cart Animation Start */
        //setTimeout(() => {
            var ProductStickyAddToBag = document.querySelector('.ProductStickyAddToBag');
            if (ProductStickyAddToBag) {
                ProductStickyAddToBag.classList.remove("Disable");
                ProductStickyAddToBag.classList.add("FadeInAnimation");
            }
        //}, 2000);
        /* Product Sticky Add To Cart Animation End */

        /* Product Gallery Slider Start */
        var swiper = new Swiper(".ProductMainGallery", {
            slidesPerView: 1,
            lazy: true,
            loop: false,
            hashNavigation: {
                watchState: true
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        });

        swiper.on('slideChangeTransitionEnd', function () {
            var currentSlideIndex = swiper.realIndex;
            var totalSlides = swiper.slides.length;

            var prevButton = document.querySelector('.swiper-button-prev');
            var nextButton = document.querySelector('.swiper-button-next');

            if (prevButton) {
                prevButton.classList.toggle('swiper-button-disabled', currentSlideIndex === 0);
            }

            if (nextButton) {
                nextButton.classList.toggle('swiper-button-disabled', currentSlideIndex === totalSlides - 1);
            }
        });
        /* Product Gallery Slider End */


        /* Product Rightbar Variation Start */
        var section = document.getElementById('rightBar');
        if (section) {
            var productType = section.getAttribute('data-type');

            if (productType === 'bundle') {

                var productOptions = document.querySelectorAll('.ProductButton');
                var singleButton = document.querySelector('.ProductButton[data-variant="single"]');
                var stickyPriceElement = document.querySelector('.sticky-product-price');
                var stickyTitleElement = document.querySelector('.sticky-product-title');
                var originalPrice = stickyPriceElement.textContent;

                var addToBagMobile = document.querySelector('.add-to-bag-mobile');
                var addToCartForm = document.querySelector('.add-to-cart-form');
                var addToCartFormMobile = document.querySelector('.add-to-cart-form-mobile');

                var singleDescription = document.querySelector('.ProductDescriptionSingle');
                var bundleDescription = document.querySelector('.ProductDescriptionBundle');

                var singleTitleElement = document.querySelector('.RightbarProductSingleName');
                var bundleTitleElement = document.querySelector('.RightbarProductBundleName');
                var singlePriceElement = document.querySelector('.RightbarProductSinglePrice');
                var bundlePriceElement = document.querySelector('.RightbarProductBundlePrice');
                var ProductStickySinglePriceWrapper = document.querySelector('.ProductStickySinglePriceWrapper');
                var ProductStickyBundlePriceWrapper = document.querySelector('.ProductStickyBundlePriceWrapper');

                productOptions.forEach(button => {
                    button.addEventListener('click', function (event) {
                        productOptions.forEach(node => {
                            node.classList.remove('active');
                        });
                        this.classList.add('active');

                        let variant = this.getAttribute('data-variant');

                        /* Rightbar click and swiper updated code start */
                        let slides = document.querySelectorAll('.ProductMainGallery .swiper-slide');

                        slides.forEach(slide => {
                            let img = slide.querySelector('img');
                            let video = slide.querySelector('video');

                            let matchVariant = (element, variant) => {
                                return element.getAttribute('data-variant') === variant ||
                                    element.getAttribute('data-variant') === 'both' ||
                                    (variant === 'refurbsingle' && element.getAttribute('data-variant') === 'single') ||
                                    (variant === 'refurbbundle' && element.getAttribute('data-variant') === 'bundle');
                            };

                            if ((img && matchVariant(img, variant)) || (video && matchVariant(video, variant))) {
                                slide.style.display = 'flex';
                            } else {
                                slide.style.display = 'none';
                            }
                        });
                        swiper.update();
                        /* Rightbar click and swiper updated code End */


                        /* Rightbar Infos text Start */
                        var productInfo = document.querySelectorAll('.productInfo');
                        productInfo.forEach(info => {
                            let dataVariant = info.getAttribute('data-variant');

                            if (dataVariant === 'both' || dataVariant === variant) {
                                info.style.display = 'flex';
                            } else {
                                info.style.display = 'none';
                            }
                        });
                        /* Rightbar Infos text End */

                        let url = new URL(window.location.href);
                        url.searchParams.set('variant', variant);
                        window.history.pushState({path: url.href}, '', url.href);

                        let titleSingle = this.getAttribute('data-title-single');
                        let titleBundle = this.getAttribute('data-title-bundle');
                        let productId = this.getAttribute('data-product-id');
                        let productSingleId = this.getAttribute('data-single-id');
                        let planId = this.getAttribute('data-selling-plan-id');
                        let bundlePrice = this.getAttribute('data-price');

                        if (variant === 'single') {
                            bundlePriceElement.classList.add('Disable');
                            bundleTitleElement.classList.add('Disable');
                            ProductStickyBundlePriceWrapper.classList.add('Disable');
                            bundleDescription.classList.add('Disable');

                            singlePriceElement.classList.remove('Disable');
                            singleTitleElement.classList.remove('Disable');
                            addToCartFormMobile.classList.remove("Disable");
                            addToCartForm.classList.remove("Disable")
                            ProductStickySinglePriceWrapper.classList.remove('Disable');
                            singleDescription.classList.remove('Disable');

                            stickyTitleElement.textContent = titleSingle;
                            addToBagMobile.textContent = "カートに追加 - " + originalPrice;


                            /* Rightbar single click remove inputs start */
                            let inputsToRemoveDesktop = addToCartForm.querySelectorAll('.ProductInput');
                            inputsToRemoveDesktop.forEach(input => {
                                input.remove();
                            });

                            let inputsToRemoveMobile = addToCartFormMobile.querySelectorAll('.ProductInput');
                            inputsToRemoveMobile.forEach(input => {
                                input.remove();
                            });
                            /* Rightbar single click remove inputs End */

                            let smart_pay = document.querySelector('.smartpay-osm-product');
                            if (smart_pay) {
                                smart_pay.style.display = "block"
                            }

                        } else if (variant === 'bundle') {

                            let smart_pay = document.querySelector('.smartpay-osm-product');
                            if (smart_pay) {
                                smart_pay.style.display = "none"
                            }


                            singleDescription.classList.add('Disable');
                            singleTitleElement.classList.add('Disable');
                            singlePriceElement.classList.add('Disable');
                            ProductStickySinglePriceWrapper.classList.add('Disable');

                            addToCartFormMobile.classList.remove("Disable");
                            addToCartForm.classList.remove("Disable")
                            bundleTitleElement.classList.remove('Disable');
                            bundlePriceElement.classList.remove('Disable');
                            ProductStickyBundlePriceWrapper.classList.remove('Disable');
                            bundleDescription.classList.remove('Disable');

                            stickyTitleElement.textContent = titleBundle;

                            var bundleElement = document.querySelector('.ProductStickyBundlePriceWrapper');
                            var bundleDiscount = bundleElement.getAttribute('data-bundle-discount');

                            if (bundleDiscount && bundleDiscount !== "blank") {
                                addToBagMobile.textContent = "カートに追加 - " + bundleDiscount;
                            } else {
                                addToBagMobile.textContent = "カートに追加 - " + bundlePrice;
                            }

                            let ProductInput = addToCartForm.querySelector('.ProductInput');
                            if (!ProductInput) {
                                appendProductInputs(addToCartForm, productId, planId);
                            }

                            let ProductInputMobile = addToCartFormMobile.querySelector('.ProductInput');
                            if (!ProductInputMobile) {
                                appendProductInputs(addToCartFormMobile, productId, planId);
                            }

                        }
                    });
                });
            } else if (productType === 'package') {
                var packageProduct = document.getElementById('product-info');
                if (packageProduct) {
                    var bundleId = packageProduct.getAttribute('data-bundle-id');
                    var bundlePrice = packageProduct.getAttribute('data-bundle-price');

                    var priceSpan = document.querySelector('.sticky-product-price');
                    var rightbarPriceSpan = document.querySelector('.RightbarProductSinglePrice .Text2');
                    if (priceSpan) priceSpan.textContent = bundlePrice;
                    if (rightbarPriceSpan) rightbarPriceSpan.textContent = bundlePrice;

                    var addToBagMobilePackage = document.querySelector('.add-to-bag-mobile');
                    if (addToBagMobilePackage) {
                        addToBagMobilePackage.textContent = `カートに追加 - ${bundlePrice}`;
                    }

                    var addToCartForms = document.querySelectorAll('.add-to-cart-form, .add-to-cart-form-mobile');
                    addToCartForms.forEach(function (form) {
                        var inputId = document.createElement('input');
                        inputId.setAttribute('type', 'hidden');
                        inputId.setAttribute('name', 'items[1][id]');
                        inputId.setAttribute('value', bundleId);
                        inputId.setAttribute('class', 'ProProductInput');

                        var inputQuantity = document.createElement('input');
                        inputQuantity.setAttribute('type', 'hidden');
                        inputQuantity.setAttribute('name', 'items[1][quantity]');
                        inputQuantity.setAttribute('value', '1');
                        inputQuantity.setAttribute('class', 'ProProductInput');

                        form.appendChild(inputId);
                        form.appendChild(inputQuantity);
                    });
                } else {
                    console.error('Product info element with ID "product-info" not found.');
                }
            }
        }
        /* Product Rightbar Variation End */

        /* Product Page Load Click Start */
        if (singleButton) {
            singleButton.click();
        }
        /* Product Page Load Click End */

        // Product Variations Start

        let selectedVariants = {};

        function formatMoney(number) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'JPY',
                minimumFractionDigits: 0
            }).format(number);
        }

        document.querySelectorAll('.ProductVariant').forEach(function (variant) {
            var priceCents = parseFloat(variant.getAttribute('data-price'));
            if (isNaN(priceCents)) {
                console.error('Wrong price:', priceCents);
                return;
            }
            var price = priceCents / 100;
            var variantId = variant.getAttribute('data-variant-id');

            selectedVariants[variantId] = {quantity: 0, price: price};

            var quantityInput = variant.querySelector('.ProductQuantityInput');
            quantityInput.value = 1;

            variant.querySelector('.plus-btn').addEventListener('click', function () {
                var currentValue = parseInt(quantityInput.value);
                quantityInput.value = currentValue + 1;
                selectedVariants[variantId].quantity = currentValue + 1;
                updateTotalPrice();
                if (currentValue + 1 > 0) {
                    variant.classList.add('active');
                }
            });

            variant.querySelector('.minus-btn').addEventListener('click', function () {
                var currentValue = parseInt(quantityInput.value);
                if (currentValue > 0) {
                    quantityInput.value = currentValue - 1;
                    selectedVariants[variantId].quantity = currentValue - 1;
                    updateTotalPrice();
                    if (currentValue - 1 === 0) {
                        variant.classList.remove('active');
                    }
                }
            });
        });

        function updateTotalPrice() {
            var totalPrice = 0;
            for (var variantId in selectedVariants) {
                var variant = selectedVariants[variantId];
                totalPrice += variant.quantity * variant.price;
            }
            document.querySelector('.sticky-product-price').textContent = formatMoney(totalPrice);
            document.getElementById('mobileTotalPrice').textContent = formatMoney(totalPrice);
        }

        document.querySelector('.add-to-cart-form-variant')?.addEventListener('submit', function (e) {
            e.preventDefault();
            this.innerHTML = '';
            let index = 0;

            if (Object.keys(selectedVariants).length === 0) {
                this.innerHTML += `<input type="hidden" name="items[0][id]" value="">
                           <input type="hidden" name="items[0][quantity]" value="1">`;
            } else {
                for (const [variantId, variantData] of Object.entries(selectedVariants)) {
                    const q = variantData.quantity ? variantData.quantity : 1;
                    this.innerHTML += `<input type="hidden" name="items[${index}][id]" value="${variantId}">
                               <input type="hidden" name="items[${index}][quantity]" value="${q}">`;
                    index++;
                }
            }

            this.innerHTML += '<button type="submit" class="add-to-bag">Add to Cart</button>';
            this.submit();
        });

        document.querySelector('.add-to-cart-form-variant-mobile')?.addEventListener('submit', function (e) {
            e.preventDefault();
            this.innerHTML = '';
            let index = 0;

            if (Object.keys(selectedVariants).length === 0) {
                this.innerHTML += `<input type="hidden" name="items[0][id]" value="">
                           <input type="hidden" name="items[0][quantity]" value="1">`;
            } else {
                for (const [variantId, variantData] of Object.entries(selectedVariants)) {
                    const q = variantData.quantity ? variantData.quantity : 1;
                    this.innerHTML += `<input type="hidden" name="items[${index}][id]" value="${variantId}">
                               <input type="hidden" name="items[${index}][quantity]" value="${q}">`;
                    index++;
                }
            }
            this.innerHTML += `<button type="submit" class="add-to-variation-mobile" data-base-text="カートに追加 - ">
                           カートに追加 - <span id="mobileTotalPrice"></span>
                       </button>`;
            this.submit();
        });


        // Product Variations End
    }
);
